import instance from "api/instance";

const getKitiRecharges = async (params) => {
  const response = await instance.get("/admin/kiti-recharge", {
    params: params
  });
  if (response.status === 200) {
    return response.data;
  }

  return Promise.reject(response.data);
};

const kitiRechargeService = {
  getKitiRecharges,
};

export default kitiRechargeService;